import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Card, Table, Badge } from "react-bootstrap";
import Sidebar from "../../layout/Sidebar/SideBar";
import Navbar from "../../layout/Navbar/Navbar";
import blogFetch from "../../axios/config";
import { StatusHse, dataHse } from "./statusHse";

// Mesmo prazo em que o back bloqueia o colaborador.
const DIAS_CRITICO = 7;

const Kpi = ({ titulo, valor, detalhe, cor }) => (
  <Card className="h-100 shadow-sm" style={{ borderLeft: `6px solid var(--bs-${cor})` }}>
    <Card.Body>
      <div className="text-muted small text-uppercase">{titulo}</div>
      <div className={`fw-bold display-6 text-${cor}`}>{valor}</div>
      <div className="small text-muted">{detalhe}</div>
    </Card.Body>
  </Card>
);

export const PainelHse = () => {
  const [painel, setPainel] = useState(null);

  useEffect(() => {
    blogFetch
      .get("/sga/dashboard")
      .then((res) => setPainel(res.data))
      .catch((err) => console.error(err));
  }, []);

  return (
    <>
      <Sidebar />
      <Navbar />
      <Container fluid className="app_body py-4">
        <h3 className="fw-bold text-center mb-4">Painel HSE - Terceiros</h3>

        {painel && (
          <>
            <Row className="g-3 mb-4">
              <Col md={3}>
                <Kpi titulo="Liberados" cor="success" valor={painel.liberados}
                  detalhe={`de ${painel.totalColaboradores} colaboradores`} />
              </Col>
              <Col md={3}>
                <Kpi titulo="Docs a vencer (30 dias)" cor="warning" valor={painel.vencer30}
                  detalhe={`7d: ${painel.vencer7} · 15d: ${painel.vencer15} · 30d: ${painel.vencer30}`} />
              </Col>
              <Col md={3}>
                <Kpi titulo="Bloqueados" cor="danger" valor={painel.bloqueados}
                  detalhe={`${painel.comPendencia} com pendências`} />
              </Col>
              <Col md={3}>
                <Kpi titulo="Aguardando análise" cor="primary" valor={painel.aguardandoAnalise}
                  detalhe={<Link to="/hse/fila">Abrir fila de aprovação</Link>} />
              </Col>
            </Row>

            <Row className="g-3">
              <Col lg={8}>
                <h5 className="fw-bold">Documentos vencendo nos próximos 15 dias</h5>
                <Table striped bordered hover className="align-middle text-center">
                  <thead className="table-dark">
                    <tr>
                      {["Colaborador", "Empresa", "Documento", "Vencimento", "Dias", "Situação"].map((c) => (
                        <th key={c}>{c}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {painel.alertas.length ? (
                      painel.alertas.map((a, i) => {
                        const critico = a.diasRestantes <= DIAS_CRITICO;
                        return (
                          <tr key={i}>
                            <td>{a.colaborador}</td>
                            <td>{a.empresa}</td>
                            <td>{a.tipo}</td>
                            <td>{dataHse(a.dataValidade)}</td>
                            <td>{a.diasRestantes}</td>
                            <td>
                              <Badge bg={critico ? "danger" : "warning"} text={critico ? undefined : "dark"}>
                                {critico ? "CRÍTICO" : "ATENÇÃO"}
                              </Badge>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-muted fst-italic">Nenhum documento vencendo.</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Col>

              <Col lg={4}>
                <h5 className="fw-bold">Empresas com pendências</h5>
                {painel.empresasComPendencia.map((e) => (
                  <Card key={e.nomeFantasia} className="mb-2 shadow-sm">
                    <Card.Body className="d-flex justify-content-between align-items-center">
                      <div>
                        <div className="fw-bold">{e.nomeFantasia}</div>
                        <div className="small text-muted">{e.tipoServico}</div>
                        <StatusHse status={e.status} />
                      </div>
                      <Badge bg="danger" pill className="fs-6">{e.pendencias}</Badge>
                    </Card.Body>
                  </Card>
                ))}
              </Col>
            </Row>
          </>
        )}
      </Container>
    </>
  );
};
